import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const StudentDashboard = ({base_url}) => {
    const [examIds, setExamIds] = useState([]);

    useEffect(() => {
        fetch(`${base_url}/exams`)  // Fetch the JSON file from the public folder
            .then((response) => response.json())
            .then((data) => {
                console.log(data)
                if (Array.isArray(data.exams)) {
                    setExamIds(data.exams);
                } else {
                    console.error("Invalid exam list format:", data);
                }
            })
            .catch((error) => console.error("Error fetching exam IDs:", error));
    }, [base_url]);

    return (
        <div className="flex flex-col items-center min-h-screen bg-gray-100 p-5">
            <h1 className="text-3xl font-bold mb-6">Available Exams</h1>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                {examIds.map((id) => (
                    <div key={id} className="p-5 bg-white shadow-lg rounded-lg text-center">
                        <h2 className="text-xl font-semibold">Exam {id}</h2>
                        <div className="flex space-x-2 mt-3">
                            <Link to={`/reading/${id}`} className="px-3 py-2 bg-blue-500 text-white rounded hover:bg-blue-600">Reading</Link>
                            <Link to={`/listening/${id}`} className="px-3 py-2 bg-green-500 text-white rounded hover:bg-green-600">Listening</Link>
                            <Link to={`/writing/${id}`} className="px-3 py-2 bg-red-500 text-white rounded hover:bg-red-600">Writing</Link>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default StudentDashboard;
